import { Component, Input } from '@angular/core';
import { Subject, debounceTime, distinctUntilChanged } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { ClientsService } from 'src/app/services/clients.service';

@Component({
    selector: 'app-client-users',
    templateUrl: './client-users.component.html',
    styleUrl: './client-users.component.scss',
    standalone: false
})
export class ClientUsersComponent {
	users: any[] = [];
  currentPage: number = 1;
  pageSize: number = 8;
  totalUsers: number = 0;
  searchText: string = '';
  sortColumn: string = 'createdAt';
  sortDirection: string = 'desc';

	startIndex: number = 0;
  endIndex: number = 0;

	@Input() currentClient!: any;
	loading = true;
	isOwner = false;

	private searchSubject = new Subject<string>();

	constructor(private clientsService: ClientsService, private authService: AuthService) {}

	ngOnInit(): void {
		this.getUsers();

    // Subscribe to search input changes with debounce
    this.searchSubject.pipe(
      debounceTime(300), // Adjust debounce time as needed
      distinctUntilChanged()
    ).subscribe(() => {
      this.currentPage = 1; // Reset to first page when search text changes
      this.getUsers();
    });
	}

	getUsers() {
		this.loading = true;
    const params = {
      page: this.currentPage.toString(),
      pageSize: this.pageSize.toString(),
      searchText: this.searchText,
      sortColumn: this.sortColumn,
      sortDirection: this.sortDirection
    };

		this.clientsService.getClientUsers(this.currentClient.id, params).subscribe({
			next: (response: any) => {
				this.users = response.users;
				this.totalUsers = response.totalUsers;
				this.calculateIndexes();
				this.loading = false;
			},
			error: (err) => {
				this.authService.toastErrorMessage(err.message ? err.message : err, 'Client Users');
			}
		});
  }

	onPageChange(page: number) {
    this.currentPage = page;
    this.getUsers();
  }

  onSearch() {
    this.searchSubject.next(this.searchText);
  }

  onSort(column: string) {
    if (this.sortColumn === column) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumn = column;
      this.sortDirection = 'asc';
    }
    this.getUsers();
  }

	calculateIndexes() {
    this.startIndex = (this.currentPage - 1) * this.pageSize + 1;
    this.endIndex = Math.min(this.currentPage * this.pageSize, this.totalUsers);
  }
}
